import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { IUser } from '../../interfaces/user.interface';
import { ConfigService } from '@core-argos-angular-artifact/core';

@Component({
  selector: 'my-account-user-cancelation',
  templateUrl: './user-cancelation.component.html',
  styleUrls: ['./user-cancelation.component.scss']
})
export class UserCancelationComponent implements OnInit, OnDestroy {
  redirectLink: string;

  user: IUser;

  constructor(
    private readonly userService: UserService,
    private readonly configService: ConfigService
  ) {
    this.redirectLink = this.configService.getConfig()?.productUrl;
  }

  ngOnInit(): void {
    this.userService.getUser().subscribe((user: IUser) => {
      this.user = { ...user };
    });
  }

  ngOnDestroy(): void {
    this.userService.resetUser();
    this.userService.resetUserApps();
  }
}
